import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ROUTE_ID_DP_START_LOADING = 'GET_ROUTE_ID_DP_START_LOADING';
export const GET_ROUTE_ID_DP_START_SUCCESS = 'GET_ROUTE_ID_DP_START_SUCCESS';
export const GET_ROUTE_ID_DP_START_REJECT = 'GET_ROUTE_ID_DP_START_REJECT';

//* ACTIONS ------------------------------------------------
export const getRouteIdDPStartLoading = () => ({ type: GET_ROUTE_ID_DP_START_LOADING });
export const getRouteIdDPStartSuccess = (payload) => ({ type: GET_ROUTE_ID_DP_START_SUCCESS, payload });
export const getRouteIdDPStartReject = (payload) => ({ type: GET_ROUTE_ID_DP_START_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getRouteIdDPStartRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.GET,
        data,
    }, getState);
    return request(`/Route/web/GetRouteStartDeliveryPointByCustomerId?CustomerId=${data.customerId}&DivisionId=${data.divisionId}`, options);
};
